<template>
<ion-menu side="start" menu-id="default" type="overlay">
  <ion-header>
    <ion-toolbar color="tertiary" @click="home">
      <ion-title>{{appName}}</ion-title>
    </ion-toolbar>
  </ion-header>
  <ion-content class="fondo-menu" color="light">
    <ion-item lines="none" color="secondary">
      <ion-avatar slot="start">
        <ion-img src="/logo.png" />
      </ion-avatar>
      <ion-label>
        <h2>{{usuario.nombre || 'INVITADO'}}
        </h2>
        <p>{{usuario.rol || 'usuario'}}</p>
      </ion-label>
      <ion-button slot="end" fill="clear" color="light" @click="logout">
        <i class="icon icon-sm ion-ios-log-out"></i>
      </ion-button>
    </ion-item>
    <ion-list @click="closeEnd" cclass="ion-padding">
      <ion-item color="light">
        <ion-label>Módulos</ion-label>
      </ion-item>
      <router-link v-for="c in menu.modulos.filter(m=>!m.ocultar)" :key="c.link" :to="'/'+c.link">
        <ion-item :hhref="'/'+c.link">
          <ion-note slot="start" color="primary">
            <i :class="'icon ion-ios-'+c.icon"></i>
          </ion-note>
          <ion-label>{{c.label}}</ion-label>
        </ion-item>
      </router-link>
    </ion-list>
    <ion-item>
      <ion-note slot="start">
        <i class="icon ion-ios-search"></i>
      </ion-note>
      <ion-label>Ir a orden</ion-label>
      <ion-input :value="queryOrden" v-on:ionChange="queryOrden=$event.detail.value" v-on:keyup.enter="buscarFolio"></ion-input>
      <ion-button slot="end" v-if="queryOrden!=''" fill="solid" color="light" @click="buscarFolio">Ir</ion-button>
    </ion-item>
    <ion-list @click="closeEnd" v-if="usuario.rol=='administrador' || usuario.permiso_gestionaCatalogos">
      <ion-item color="light">
        <ion-label>Catálogos</ion-label>
      </ion-item>
      <router-link :to="'/catalogos/'+c.link" v-for="c in menu.catalogos" :key="c.link">
        <ion-item>
          <ion-note slot="start" color="primary">
            <i :class="'icon ion-ios-'+c.icon"></i>
          </ion-note>
          <ion-label>{{c.label}}</ion-label>
        </ion-item>
      </router-link>
    </ion-list>
  </ion-content>
</ion-menu>
</template>
<script>
import Api from '@/components/Api/Api'
export default {
  name: 'Menu',
  props: {
    usuario: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data() {
    return {
      appName: Api.appName,
      queryOrden: '',
      menu: {
        catalogos: [{
          label: 'Usuarios',
          link: 'usuarios',
          icon: 'person'
        }, {
          label: 'Brandings',
          link: 'brandings',
          icon: 'cube'
        }, {
          label: 'Clientes',
          link: 'clientes',
          icon: 'people'
        }, {
          label: 'Equipos',
          link: 'equipos',
          icon: 'cog'
        }, {
          label: 'Importar',
          link: 'importar',
          icon: 'cloud-upload'
        }, {
          label: 'Config de empresa',
          link: 'empresa',
          icon: 'cog'
        }],
        modulos: [{
          label: 'Agenda',
          link: 'agenda',
          icon: 'calendar'
        }, {
          label: 'Órdenes de servicio',
          link: 'ordenes',
          icon: 'list',
          ocultar: !(Api.fetchLocal('cmms.yo') || {}).permiso_creaOrdenesServicio
        }, {
          label: 'Reportes',
          link: 'reportes',
          icon: 'stats',
          ocultar: !(Api.fetchLocal('cmms.yo') || {}).permiso_visualizaReportes
        }, {
          label: 'Revisión de inventario',
          link: 'inventario',
          icon: 'list',
          ocultar: !(Api.fetchLocal('cmms.yo') || {}).permiso_visualizaReportes
        }]
      }
    }
  },
  methods: {
    closeEnd() {
      Api.$emit('close-menu')
    },
    home() {
      this.$router.push('/')
      this.closeEnd()
    },
    async buscarFolio() {
      try {
        let ordenes = await Api.find('ordenservicio', ['folio,eq,' + this.queryOrden], {
          limit: 1
        })
        let orden = ordenes[0]
        this.$router.push('/hola')
        await Api.wait(100)
        this.$router.push('/ordenes/' + orden._id)
        toast("Orden encontrada")
        await Api.wait(1000)
        this.closeEnd()
      } catch (e) {
        console.error(e)
        alert("No se pudo encontrar la orden")
        this.queryOrden = ''
      }
    },
    logout() {
      Api.$emit('logged-in', {})
    }
  }
}
</script>
